import type { QueryClient } from '@tanstack/react-query'
import { currentUserKeys } from '@/hooks/queries/useCurrentUser'
import { profileKeys } from '@/hooks/queries/useProfile'
import { freelancersListKeys } from '@/hooks/queries/useFreelancersList'
import { freelancerDetailKeys } from '@/hooks/queries/useFreelancerDetail'
import { devicesToolsKeys } from '@/hooks/queries/useDevicesTools'

/**
 * Invalide les listes/détails qui affichent un avatar après upload ou changement de photo.
 */
export function invalidateProfileAvatarQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: profileKeys.all })
  queryClient.invalidateQueries({ queryKey: currentUserKeys.all })
  queryClient.invalidateQueries({ queryKey: freelancersListKeys.all })
  queryClient.invalidateQueries({ queryKey: freelancerDetailKeys.all })
  queryClient.invalidateQueries({ queryKey: ['missions'] })
  queryClient.invalidateQueries({ queryKey: ['activityReports'] })
  queryClient.invalidateQueries({ queryKey: devicesToolsKeys.all })
  queryClient.invalidateQueries({ queryKey: ['availability'] })
  queryClient.invalidateQueries({ queryKey: ['dashboardData'] })
}
